import React, { useState, useEffect } from "react";
import convertToIST from "../../../../../services/istTime";
import api from "../../../../../services/api";
import { useToast } from "../../../../../mesageToast/ToastContainer";
import { useDispatch } from "react-redux";
import { updateStaus } from "../../../../../redux/Slice/OrderSlice";
import UpdatePopup from "../InPreogress/UpdateModal";

function CancelledTakeAway({ items, status, refresh }) {
  const [showData, setShowData] = useState([]);
  const [processingOrder, setProcessingOrder] = useState(null);
  const [cancelOrder, setCancelOrder] = useState(null);
  const [updateOrder, setUpdateOrder] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [initialStatus, setInitialStatus] = useState("");
  const [delayTime, setDelayTime] = useState(null);
  const [copied, setCopied] = useState(false);
  const addToast = useToast();
  const dispatch = useDispatch();

  useEffect(() => {
    setShowData(
      items.filter((order) => {
        return order.user.orderStatus === status;
      })
    );
  }, [items, status]);

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 1000);
  };

  const openUpdateModal = (order) => {
    setUpdateOrder(order);
    setSelectedStatus(order.user?.orderStatus || "");
    setInitialStatus(order.user?.orderStatus || "");
    setDelayTime(null);
  };

  const closeUpdateModal = () => {
    setUpdateOrder(null);
    setSelectedStatus(null);
    setInitialStatus("");
    setDelayTime(null);
  };

  const handleUpdateStatus = async (orderId) => {
    if (!selectedStatus) {
      addToast("Error", "Please select a status to update.", "error");
      return;
    }

    try {
      await api.patch(`/restaurant-management/orders/UpdateStatus/${orderId}`, {
        status: selectedStatus,
      });
      dispatch(updateStaus({ id: orderId, status: selectedStatus }));
      addToast("Status Updated", `Order status updated to ${selectedStatus}.`, "success");
      closeUpdateModal();
      if (refresh) refresh();
    } catch (error) {
      addToast(
        "Error",
        error.response?.data?.message || "Failed to update no-show order status.",
        "error"
      );
    }
  };

  const handleCancelNoShow = async (orderId) => {
    setProcessingOrder(orderId);
    try {
      const response = await api.post(`/orders/${orderId}/cancel-no-show`);
      const updatedStatus = response.data?.data?.status || "Cancelled";

      dispatch(updateStaus({ id: orderId, status: updatedStatus }));
      setShowData((currentOrders) =>
        currentOrders.map((order) =>
          order.id === orderId
            ? {
                ...order,
                user: {
                  ...order.user,
                  orderStatus: updatedStatus,
                },
              }
            : order
        )
      );

      addToast("Status Updated", `Order status updated to ${updatedStatus}.`, "success");
      setCancelOrder(null);
      if (refresh) refresh();
    } catch (error) {
      addToast(
        "Error",
        error.response?.data?.message || "Failed to update no-show order status.",
        "error"
      );
    } finally {
      setProcessingOrder(null);
    }
  };

  return (
    <>
      <table className="inProgressTable">
        <thead>
          <tr>
            <th>Order ID</th>
            <th>Name</th>
            <th>Order Time</th>
            <th>Pickup Time</th>
            <th>Items</th>
            <th>Total Amt.</th>
            <th>Payment</th>
            <th>Status</th>
            {status === "Cancelled" && <th>Remark</th>}
            {status === "No-Show" && <th>Action</th>}
          </tr>
        </thead>
        <tbody>
          {showData.length === 0 ? (
            <tr>
              <td colSpan="9">No Records Available</td>
            </tr>
          ) : (
            showData.map((item) => (
              <tr key={item.id}>
                <td>
                  <p>{item.id}</p>
                </td>
                <td>{item.user.name}</td>
                <td>{convertToIST(item.createdTime).time}</td>
                <td>{item.user.pickupTime}</td>
                <td>{item.user.items.length}</td>
                <td> {item.user.subTotal}</td>
                <td>Paid</td>
                <td>
                  <span className={`order-status-badge ${item.user.orderStatus === "No-Show" ? "no-show" : ""}`}>
                    {item.user.orderStatus}
                  </span>
                </td>
                {status === "Cancelled" && (
                  <td>
                    {item.user.orderStatus === "Cancelled" &&
                    item.user.comment === "Cancelled from User"
                      ? "User"
                      : item.user.vendorComment !== "Cancelled from User"
                      ? "Restaurant"
                      : "-"}
                  </td>
                )}
                {status === "No-Show" && (
                  <td>
                    {item.user.orderStatus === "No-Show" ? (
                      <div className="no-show-actions">
                        <button
                          className="mark-unavailable"
                          onClick={() => openUpdateModal(item)}
                        >
                          Update Details
                        </button>
                        <button
                          className="delete"
                          onClick={() => setCancelOrder(item)}
                          disabled={processingOrder === item.id}
                        >
                          Cancel
                        </button>
                      </div>
                    ) : (
                      <span className="status-updated-text">Updated</span>
                    )}
                  </td>
                )}
              </tr>
            ))
          )}
        </tbody>
      </table>
      {updateOrder && (
        <UpdatePopup
          item={updateOrder}
          status={selectedStatus}
          setStatus={setSelectedStatus}
          delayTime={delayTime}
          setDelayTime={setDelayTime}
          handleStatusChange={setSelectedStatus}
          handleUpdateStatus={handleUpdateStatus}
          handleClosePopup={closeUpdateModal}
          copyToClipboard={copyToClipboard}
          copied={copied}
          initialStatus={initialStatus}
          allowNoShowUpdate
          statusOptions={["Ready", "Completed"]}
        />
      )}
      {cancelOrder && (
        <div className="confirm-popup">
          <div className="confirm-popup-content">
            <h4>Cancel Order</h4>
            <p>Are you sure you want to cancel order #{cancelOrder.id}?</p>
            <div className="buttons">
              <button className="Close" onClick={() => setCancelOrder(null)}>
                Close
              </button>
              <button
                className="Update"
                onClick={() => handleCancelNoShow(cancelOrder.id)}
                disabled={processingOrder === cancelOrder.id}
              >
                {processingOrder === cancelOrder.id ? "Cancelling..." : "Yes, Cancel"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
export default CancelledTakeAway;
